import { clsx } from 'clsx'
import type { ReactNode } from 'react'
import styles from './Badge.module.css'

export type BadgeTone = 'neutral' | 'alive' | 'out' | 'live' | 'money'
export type BadgeVariant = 'soft' | 'solid' | 'outline'

type BadgeProps = {
  tone?: BadgeTone
  variant?: BadgeVariant
  size?: 'sm' | 'md'
  /** Leading status dot — "Vivo", "Ao vivo". */
  hasDot?: boolean
  className?: string | undefined
  children: ReactNode
}

/**
 * A state label. Tone is a claim about state, not decoration: `alive`, `out`
 * and `live` are the only colours this design spends, so do not reach for one
 * to make a neutral chip look livelier.
 */
export function Badge({
  tone = 'neutral',
  variant = 'soft',
  size = 'sm',
  hasDot = false,
  className,
  children,
}: BadgeProps) {
  return (
    <span className={clsx(styles.badge, styles[tone], styles[variant], styles[size], className)}>
      {hasDot && <span className={styles.dot} aria-hidden="true" />}
      {children}
    </span>
  )
}
